import { render, staticRenderFns } from "./Consentimiento.vue?vue&type=template&id=51e92332&"
import script from "./Consentimiento.vue?vue&type=script&lang=js&"
export * from "./Consentimiento.vue?vue&type=script&lang=js&"
import style0 from "./Consentimiento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports